import React, { useEffect, useRef, useState } from 'react';
import styles from './homePageNew.module.scss';
import AppHeader from '../../containers/Header';
import CaseStudyModal from "../CaseStudyModal/CaseStudyModal";
import { useLocation } from "react-router-dom";
import teamHandImage from '../../assets/HomePage/teamTopSection.svg';
import {
  TopRightCornerBgImage,
  MidLeftHalfSettingBg,
  MidRightHalfSettingBg,
  DemoVideoThumbnail,
  BlinkingStar,
  GrowthChart,
  Rocket,
  ConsistencyIcon,
  CostSavingIcon,
  EasyImplementationIcon,
  ErrorReductionIcon,
  FasterProcessIcon,
  ImprovedComplianceIcon,
  OperationsIcon,
  SamLessIntegrationIcon,
  ScalabilityIcon,
  TraceabilityIcon,
  HowItWorksImage,
  UserIcon,
  MinimalLicenseFeeIcon,
  RpaServiceIcon,
  ProcessIcon,
  AiDrivenIcon,
  DefaultImage,
  DevelopmentImage,
  TestingImage,
  SupportImage,
  ManageProjectStar,
  PlanningImage,
  AccountingIcon,
  ApplicationMigrationIcon,
  BankingIcon,
  BackOfficeIcon,
  CustomerServiceIcon,
  DataEntryIcon,
  DecisionMakingIcon,
  FrontOfficeIcon,
  HealthCareIcon,
  HRIcon,
  InsuranceIcon,
  ManufacturingIcon,
  MarketingIcon,
  ProductivityIcon,
  RecruitmentIcon,
  ReportPreparationIcon,
  RetailIcon,
  STPIcon,
  SystemIntegrationIcon,
  TelecommunicationIcon,
  UseCaseImage,
  DomainImage,
  FunctionImage,
  InformationValidating,
  LeftArrowIcon,
  RightArrowIcon,
  HowToTransformBgImage,
  GlobalFootPrintBgImage,
  LogoTft,
  MailIcon,
  LinkedIcon,
  XIcon,
  InstagramIcon,
  FacebookIcon,
  CaseStudyBSESImage,
  CaseStudyGiGroupImage,
  SkypeIcon,
  RatingStart,
  PurpleBg,
  OutlinedRatingStart,
  RatingProfileAvatar1,
  RatingProfileAvatar2,
  RatingProfileAvatar3,
} from '../../assets/HomePage';
import demoVideo from '../../assets/HomePage/img.mp4';
import aboutUsImage from '../../assets/HomePage/aboutUsImage.png';
import RequestDemo from '../RequestDemoForm/RequestDemo';
import ROICalculator from '../ROICalculator/ROICalculator';
import { Carousel } from 'antd';
import CaseStudyContent from '../CaseStudyModal/CaseStudyContent';
import { CASE_STUDIES, clients } from '../../constants/caseStudies';
import DoubleCircleLoader from '../DoubleCircleLoader/Index';
const streamLineSlideIcons = [
  [
    {
      icon: <SystemIntegrationIcon />,
      label: 'Virtual System Integration',
    },
    {
      icon: <DecisionMakingIcon />,
      label: 'Rule-Based Decision Making',
    },
    {
      icon: <STPIcon />,
      label: 'Straight Through Processing (STP)',
    },
    {
      icon: <ApplicationMigrationIcon />,
      label: 'Application Migration',
    },
    {
      icon: <ReportPreparationIcon />,
      label: 'Automated Report Preparation',
    },
    {
      icon: <DataEntryIcon />,
      label: 'Double Data Entry',
    },
    {
      icon: <InformationValidating />,
      label: 'Information Validation & Auditing',
    },
  ],
  [
    {
      icon: <InsuranceIcon />,
      label: 'Insurance',
    },
    {
      icon: <HealthCareIcon />,
      label: 'Healthcare',
    },
    {
      icon: <RetailIcon />,
      label: 'Retail',
    },
    {
      icon: <ManufacturingIcon />,
      label: 'Manufacturing',
    },
    {
      icon: <BankingIcon />,
      label: 'Banking',
    },
    {
      icon: <TelecommunicationIcon />,
      label: 'Telecommunications',
    },
  ],
  [
    {
      icon: <ProductivityIcon />,
      label: 'Employee Productivity',
    },
    {
      icon: <BackOfficeIcon />,
      label: 'Back Office',
    },
    {
      icon: <FrontOfficeIcon />,
      label: 'Front Office',
    },
    {
      icon: <CustomerServiceIcon />,
      label: 'Customer Service',
    },
    {
      icon: <HRIcon />,
      label: 'Human Resources',
    },
    {
      icon: <MarketingIcon />,
      label: 'Sales & Marketing',
    },
    {
      icon: <RecruitmentIcon />,
      label: 'Recruitment',
    },
    {
      icon: <AccountingIcon />,
      label: 'Finance & Accounting',
    },
  ],
];

const PeopleFeedback = [
  {
    feedbackText: `“Swivel chair integration which involved one person working on multiple applications is a thing of the past now. AutomationTwin has been a game-changer for our team! Thanks to Think Future Technologies, we now have a more efficient workflow, allowing us to focus on what matters most – delivering exceptional results to our customers..\"`,
    feedbackBy: 'Director of the biggest Energy company',
    profileImage: <RatingProfileAvatar1/>,
  },
  {
    feedbackText: `"AutomationTwin - TFT's RPA solution has streamlined our operations seamlessly.
                  Tasks that once took days are now completed in minutes, freeing up valuable time
                  and resources. The efficiency gains have exceeded our expectations, making our
                  processes more agile and productive. Highly recommended!"`,

    feedbackBy: 'CIO of one of the biggest Financial Corporation',
    profileImage: <RatingProfileAvatar2/>,
  },
  {
    feedbackText: `"The cognitive intelligence solution powered by the seamless integration of
                  AutomationTwin with AI has transformed our business operations. With unparalleled
                  efficiency and accuracy, it has streamlined our processes to a great extent. Our
                  team now focuses on high-value tasks, while the solution handles repetitive tasks
                  with high precision. This has overall helped with crystallizing our workflows and
                  increased efficiency leading to overall enhanced overall productivity."`,
    feedbackBy: 'Director- IT of a Hospital',
    profileImage: <RatingProfileAvatar3/>,
  },
];

const features =[
  'Create Images',
  'Resolve IT tickets',
  'Summarise emails',
  'Research leads',
  'Coach sales calls',
  'Onboard employees',
  'Repurpose Content',
  'Centralise leads',
  'Reply to emails',
  'Prepare calls',
  'Uncover sales leads',
  'Generate Posts',
  'Assist customers',
  'Qualify Leads',
  'Help Customers',
  'Support sales reps',
  'Analyze customer feedback',
  'Develop training materials',
  'Plan marketing campaigns',
  'Track performance metrics',
  'Optimize website content',
  'Conduct competitor analysis',
  'Create newsletters',
  'Facilitate team meetings',
  'Implement customer loyalty programs',
]
const HomePageNew = () => {
  const demoVideoRef = useRef(null);
  const location = useLocation();
  const [isRequestDemo, setIsRequestDemo] = useState(false);
  const [isPlayingDemoVideo, setIsPlayingDemoVideo] = useState(false);
  const [streamLineSlideIndex, setStreamLineSlideIndex] = useState(0);
  const [isVideoPlayedFirstTime, setIsVideoPlayFirstTime] = useState(false);
  const [isCaseStudyModalOpen, setIsCaseStudyModalOpen] = useState(false);
  const [selectedCaseStudy, setSelectedCaseStudy] = useState(null);
  const selectedData = CASE_STUDIES?.[selectedCaseStudy];
  
  useEffect(() => {
    const shouldScrollToRoi =
      location.state?.scrollToRoi || new URLSearchParams(location.search).get('scrollToRoi') === 'true';

    if (shouldScrollToRoi) {
      const element = document.getElementById("roi-section");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location])
  const openRequestDemo = () => {
    setIsRequestDemo(true);
  };
  const closeRequestDemo = () => {
    setIsRequestDemo(false);
  };

  const openCaseStudy = (type) => {
  setSelectedCaseStudy(type);
  setIsCaseStudyModalOpen(true);

    document.body.style.overflow = "hidden";
  };

  const closeCaseStudy = () => {
    setIsCaseStudyModalOpen(false);
    setSelectedCaseStudy(null);

    document.body.style.overflow = "auto";
  };
  const handlePlay = () => {
    const video = demoVideoRef.current;
    if (!video) return;
    if (video.paused || video.ended) {
      video.play().catch(() => {
        setIsPlayingDemoVideo(false);
      });
    } else {
      video.pause();
    }
  };
  return (
    <>
      <AppHeader showDropdown={false} />
      <div className={styles.landingPageContainer}>
        <section className={styles.firstSection}>
          <div className={styles.topRightCornerBgImage}>
            <TopRightCornerBgImage className={styles.topCornerBgImage} />
          </div>
          <div className={styles.firstSectionContents}>
            <div className={styles.textContent}>
              <p className={styles.contentTitle}>
                <span className={styles.contentTitleSpan}>Free Your Team</span> From
                <br />
                The Work That Slows
                <br />
                Them Down
              </p>
              <p className={styles.contentDescription}>
                AutomationTwin learns how your people work, then takes over the
                <br />
                routine, rules based tasks and runs them flawlessly around the
                <br />
                clock. Fewer errors, far less manual effort, and efficiency gains
                <br />
                of 40 percent and beyond, so your team can focus on the work that
                <br />
                actually moves the business.
              </p>
              <button className={styles.requestDemoBtn} onClick={openRequestDemo}>
                Request a Demo
              </button>
            </div>

            <div className={styles.heroImage}>
              <img src={teamHandImage} alt="Team working" />
            </div>
          </div>
        </section>
        <section className={styles.demoVideoSection}>
          <div className={styles.upperSectionBg} />
          <div className={styles.demoVideoContainer}>
            <video
              ref={demoVideoRef}
              src={demoVideo}
              style={{ backgroundColor: isVideoPlayedFirstTime ? '#161C2D' : 'transparent' }}
              controls
              playsInline
              poster={DemoVideoThumbnail}
              className={styles.demoVideo}
              onPause={() => {
                setIsPlayingDemoVideo(false);
              }}
              onPlay={() => {
                setIsPlayingDemoVideo(true);
                if (!isVideoPlayedFirstTime) {
                  setIsVideoPlayFirstTime(true);
                }
              }}
              // onEnded={() => setIsPlayingDemoVideo(false)}
            />
            {/* <button
              type="button"
              className={styles.playButton}
              onClick={handlePlay}
              aria-label={isPlayingDemoVideo ? 'Pause demo video' : 'Play demo video'}
              aria-pressed={isPlayingDemoVideo}
            >
              <span
                aria-hidden="true"
                className={isPlayingDemoVideo ? styles.pauseIcon : styles.playIcon}
              />
            </button> */}
          </div>
        </section>
        <section className={styles.aboutUsSection}>
          <div className={styles.aboutUsTextContent}>
            <span className={styles.sectionHeading}>About Us</span>
            <p className={styles.sectionTitle}>
              Meet AutomationTwin
            </p>
            <p className={styles.aboutUsDescription}>
              AutomationTwin is an enterprise RPA platform that works like a digital twin of your
              workforce.
              <br /> 
              It learns how your people operate across applications, websites, and portals, then
              <br />
              carries out their routine tasks with the same logic, only faster and without the errors.
              <br />
              <br/>
              Built and powered by Think Future Technologies, AutomationTwin brings AI and
              <br />
              automation together so organisations can run leaner, move faster, and scale with confidence.
              <br />
              From everyday data entry to complex, multi step processes, it lifts the manual load off your team
              <br />
              and frees them to focus on higher value work.
            </p>
            <div className={styles.aboutUsStatsContainer}>
              <div className={styles.aboutUsStatContainer}>
                <div className={styles.aboutUsStat}>
                  <div className={styles.statIconContainer}>
                    <BlinkingStar className={styles.statIcon} />
                  </div>
                  <span className={styles.aboutUsStatCount}>{'10+'}</span>
                </div>
                <span className={styles.statDescription}>Years of AI Innovation</span>
              </div>
              <div className={styles.aboutUsStatContainer}>
                <div className={styles.aboutUsStat}>
                  <div className={styles.statIconContainer}>
                    <GrowthChart className={styles.statIcon} />
                  </div>
                  <span className={styles.aboutUsStatCount}>{'40%'}</span>
                </div>
                <span className={styles.statDescription}>Over Efficiency Gain</span>
              </div>
              <div className={styles.aboutUsStatContainer}>
                <div className={styles.aboutUsStat}>
                  <div className={styles.statIconContainer}>
                    <Rocket className={styles.statIcon} />
                  </div>
                  <span className={styles.aboutUsStatCount}>{'125+'}</span>
                </div>
                <span className={styles.statDescription}>Process successfully automated</span>
              </div>
            </div>
          </div>
          <div className={styles.aboutUsImageContainer}>
            <div className={styles.aboutUsImage}>
              <img src={aboutUsImage} />
            </div>
            <div className={styles.aboutUsRequestDemoCard}>
              <span className={styles.aboutUsRequestDemoCardTitle}>
                Ready to See Automation in Action?
              </span>
              <span className={styles.aboutUsRequestDemoCardDescription}>
                Book a short demo and see how<br/>
                AutomationTwin takes the busywork off your team's
              </span>
              <button className={styles.requestDemoBtn} onClick={openRequestDemo}>
                Request a Demo
              </button>
            </div>
          </div>
        </section>
        <section className={styles.intelligentAutonationLifeSection}>
          <div className={styles.leftBgImageContainer}>
            <MidLeftHalfSettingBg className={styles.leftBgImage} />
          </div>
          <div className={styles.rightBgImageContainer}>
            <MidRightHalfSettingBg className={styles.rightBgImage} />
          </div>
          <div className={styles.contents}>
            <p className={styles.contentTitle}>We Bring Intelligent Automation to Life</p>
            <span className={styles.description}>
              What sets AutomationTwin apart is that it acts as a virtual twin of your workforce, 
              working inside your applications, websites, and portals exactly the way your people do.
              From repetitive tasks to data entry to complex, multi step processes, it mirrors human judgement to deliver
              near-zero error rates and real savings, running every hour of every day.
            </span>
          </div>
        </section>
        <section id='roi-section' className={styles.roiSection}>
          <div className={styles.roiTextContentContainer}>
            <p className={styles.roiHeading}>See What Automation Could Return for You</p>
            <span className={styles.roiDescription}>
              Want to know what automation could be worth to your business? Adjust a few inputs
              and AutomationTwin maps the bots, agents, and monthly investment that fit your processes,
              along with the efficiency you stand to gain. A clear answer in seconds, no sales call required.
            </span>
          </div>
          <div className={styles.roiCalculatorContainer}>
            <ROICalculator />
          </div>
        </section>
        <section className={styles.roiIntoResultsSection}>
          <div className={styles.leftBgImageContainer}>
            <MidLeftHalfSettingBg className={styles.leftBgImage} />
          </div>
          <div className={styles.contents}>
            <p className={styles.contentTitle}>Turn Your ROI into Real Results</p>
            <span className={styles.description}>
              Book a quick consultation and see exactly how these savings show up in your operations.
            </span>
            <button className={styles.contactUsBtn} onClick={openRequestDemo}>
              Contact Us
            </button>
          </div>
        </section>
        <section className={styles.benefitsSection}>
          <div className={styles.rightBgImageContainer}>
            <MidRightHalfSettingBg className={styles.rightBgImage} />
          </div>
          <p className={styles.benefitsSectionTitle}>Why Businesses Move to RPA</p>
          <div className={styles.benefitsSectionContents}>
            <div className={styles.benefitCard}>
              <CostSavingIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Cost Savings</span>
              <span className={styles.benefitDescription}>
                Save 50-70% on labor costs by optimising resource usage.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <ErrorReductionIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Error Reduction</span>
              <span className={styles.benefitDescription}>
                Achieve near-zero error rates, ensuring process accuracy.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <ImprovedComplianceIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Improved Compliance</span>
              <span className={styles.benefitDescription}>
                Ensure adherence to regulations and standards.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <FasterProcessIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Faster Process</span>
              <span className={styles.benefitDescription}>
                Enhance efficiency, reducing processing time.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <SamLessIntegrationIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Seamless Integration</span>
              <span className={styles.benefitDescription}>
                No significant changes required to the existing IT infrastructure.
              </span>
            </div>
          </div>
          <div className={styles.benefitsSectionContents}>
            <div className={styles.benefitCard}>
              <EasyImplementationIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Easy Implementation</span>
              <span className={styles.benefitDescription}>
                Minimal upfront investment and setup costs.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <OperationsIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>24/7 Operations</span>
              <span className={styles.benefitDescription}>
                Automated solution works around the clock.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <TraceabilityIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Complete Traceability</span>
              <span className={styles.benefitDescription}>
                Full visibility into every robotic action and decision.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <ScalabilityIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Enterprise Scalability</span>
              <span className={styles.benefitDescription}>
                Responsive virtual workforce adaptable to demands.
              </span>
            </div>
            <div className={styles.benefitCard}>
              <ConsistencyIcon className={styles.benefitIcon} />
              <span className={styles.benefitTitle}>Consistency</span>
              <span className={styles.benefitDescription}>Double-digit reduction in errors.</span>
            </div>
          </div>
          <div className={styles.howIsItWorkContainer}>
            <div className={styles.howIsItWorkImageContainer}>
              <HowItWorksImage className={styles.howIsItWorkImage} />
            </div>
            <div className={styles.howIsItWorkTextContainer}>
              <p className={styles.howIsItWorkHeading}>Why Choose AutomationTwin</p>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIconContainer}>
                  <UserIcon className={styles.benefitIcon} />
                </div>
                <span>Effortless Setup</span>
              </div>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIconContainer}>
                  <ProcessIcon className={styles.benefitIcon} />
                </div>
                <span>Seamless Process Mapping</span>
              </div>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIconContainer}>
                  <MinimalLicenseFeeIcon className={styles.benefitIcon} />
                </div>
                <span>Clear, Scalable Pricing</span>
              </div>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIconContainer}>
                  <RpaServiceIcon className={styles.benefitIcon} />
                </div>
                <span>RPA as a Service</span>
              </div>
              <div className={styles.benefitItem}>
                <div className={styles.benefitIconContainer}>
                  <AiDrivenIcon className={styles.benefitIcon} />
                </div>
                <span>AI-driven Efficiency</span>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.manageProjectSection}>
          <p className={styles.manageProjectSectionTitle}>From First Idea to Live Automation, Fast</p>
          <span className={styles.manageProjectSectionDescription}>
            Four essential steps take you from idea to impact: Planning, Development, Testing, and 
            Support. Each one is built to get your automation live quickly, without cutting corners.
          </span>
          <div className={styles.manageProjectSectionContents}>
            <div className={styles.imageContainer}>
              <DefaultImage className={`${styles.defaultImage} ${styles.images}`} />
              <PlanningImage className={`${styles.planningImage} ${styles.images}`} />
              <DevelopmentImage className={`${styles.developmentImage} ${styles.images}`} />
              <TestingImage className={`${styles.testingImage} ${styles.images}`} />
              <SupportImage className={`${styles.supportImage} ${styles.images}`} />
              <div className={styles.imageTextBox}>
                <ManageProjectStar className={styles.starImage} />
                <span className={`${styles.imageText} ${styles.planningText}`}>
                  Set the stage for automation success.
                </span>
                <span className={`${styles.imageText} ${styles.developmentText}`}>
                  Build fast. Build smart. Automate with precision.
                </span>
                <span className={`${styles.imageText} ${styles.testingText}`}>
                  Quality matters—refine automation with rigorous testing.
                </span>
                <span className={`${styles.imageText} ${styles.supportText}`}>
                  Keep it running—monitor, support, and optimise continuous.
                </span>
              </div>
            </div>
            <div className={styles.textContentContainer}>
              <div className={`${styles.textContentCard} ${styles.planningCard}`}>
                <span className={styles.cardTitle}>Planning</span>
                <span className={styles.cardDescription}>
                  Identify automation-ready processes, define timelines, and assemble a dedicated
                  team. Design tailored RPA solutions, set up logging to catch issues, and build a
                  scalable implementation roadmap.
                </span>
                <div className={styles.step}>1</div>
              </div>
              <div className={`${styles.textContentCard} ${styles.developmentCard}`}>
                <span className={styles.cardTitle}>Development</span>
                <span className={styles.cardDescription}>
                  Implement automation workflows according to the plan. Leverage wizard-driven tools
                  for swift and efficient implementation.
                </span>
                <div className={styles.step}>2</div>
              </div>
              <div className={`${styles.textContentCard} ${styles.testingCard}`}>
                <span className={styles.cardTitle}>Testing</span>
                <span className={styles.cardDescription}>
                  Conduct thorough test cycles for the targeted automation processes. Identify and
                  rectify issues that arise during testing.
                </span>
                <div className={styles.step}>3</div>
              </div>

              <div className={`${styles.textContentCard} ${styles.supportCard}`}>
                <span className={styles.cardTitle}>Support & Maintenance</span>
                <span className={styles.cardDescription}>
                  Offer continuous support post-launch, ensuring smooth operations. Provide
                  immediate resolution for any defects encountered. Adhere to general maintenance
                  guidelines.
                </span>
                <div className={styles.step}>4</div>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.streamLineDailyProcessSection}>
          <p className={styles.sectionTitle}>
            Streamline Daily Processes with Intelligent Automation
          </p>
          <div className={styles.buttonsContainer}>
            <button
              className={`${styles.slideButton} ${streamLineSlideIndex == 0 && styles.activeButton}`}
              onClick={() => {
                setStreamLineSlideIndex(0);
              }}
            >
              Use Cases
            </button>
            <button
              className={`${styles.slideButton} ${streamLineSlideIndex == 1 && styles.activeButton}`}
              onClick={() => {
                setStreamLineSlideIndex(1);
              }}
            >
              Domain
            </button>
            <button
              className={`${styles.slideButton} ${streamLineSlideIndex == 2 && styles.activeButton}`}
              onClick={() => {
                setStreamLineSlideIndex(2);
              }}
            >
              Function
            </button>
          </div>
          <div className={styles.slideContainer}>
            <div className={styles.slideImageContainer}>
              <LeftArrowIcon
                style={{ visibility: streamLineSlideIndex == 0 ? 'hidden' : 'visible' }}
                className={styles.imageChangeButton}
                onClick={() => {
                  setStreamLineSlideIndex((streamLineSlideIndex - 1 + 3) % 3);
                }}
              />
              <div className={styles.slideImage}>
                {streamLineSlideIndex == 0 && <UseCaseImage className={styles.image} />}
                {streamLineSlideIndex == 1 && <DomainImage className={styles.image} />}
                {streamLineSlideIndex == 2 && <FunctionImage className={styles.image} />}
              </div>
              <RightArrowIcon
                style={{ visibility: streamLineSlideIndex === 2 ? 'hidden' : 'visible' }}
                className={styles.imageChangeButton}
                onClick={() => {
                  setStreamLineSlideIndex((streamLineSlideIndex + 1) % 3);
                }}
              />
            </div>
            <div className={styles.slidesIconContainer}>
              {streamLineSlideIcons[streamLineSlideIndex].map((item, index) => (
                <div key={index} className={styles.slideIconCard}>
                  <div className={styles.iconContainer}>{item.icon}</div>
                  <span>{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className={styles.howToTransformSection}>
          <div className={styles.backgroundImageContainer}>
            <HowToTransformBgImage />
          </div>
          <div className={styles.howToTransformContentContainer}>
            <p className={styles.howToTransformTitle}>How Teams Transformed with Automation</p>
            <p className={styles.howToTransformDescription}>
              Discover how leading businesses streamlined operations, cut costs, and scaled faster
              with AutomationTwin.
            </p>
            <div className={styles.caseStudyCarouselContainer}>
              <Carousel
                autoplay
                autoplaySpeed={3000}
                dots
                pauseOnDotsHover
                className={styles.customCarouselStyles}
              >
                <div>
                  <div className={styles.howToTransformCaseStudyContainer}>
                    <div className={styles.caseStudyTextContainer}>
                      <div className={styles.caseStudyContent}>
                        <p className={styles.caseStudyTitle}>Salary Automation for Gi Group</p>
                        <p className={styles.caseStudy}>
                          A global staffing company processing payroll for 50,000 to 60,000 employees faced
                          delays, errors, and heavy manual effort. Our end to end salary automation streamlined payouts,
                          tracking, and reconciliation, enabling same day disbursals, eliminating duplicate payments,
                          reducing errors to near zero, and delivering full payroll visibility that boosted both employee and
                          client confidence.
                        </p>
                      </div>
                      <span
                        className={styles.readFullCaseStudy}
                        onClick={() => setSelectedCaseStudy(clients.GI_GROUP)}
                      >
                        Read the full case study
                      </span>
                    </div>
                    <div className={styles.caseStudyImageContainer}>
                      <CaseStudyGiGroupImage />
                    </div>
                  </div>
                </div>
                <div>
                  <div className={styles.howToTransformCaseStudyContainer}>
                    <div className={styles.caseStudyTextContainer}>
                      <div className={styles.caseStudyContent}>
                        <p className={styles.caseStudyTitle}>
                          Automating Defaulter Recovery for BSES
                        </p>
                        <p className={styles.caseStudy}>
                          BSES Yamuna Power Ltd. faced slow, error-prone manual recovery cycles
                          involving multiple teams and divisions, leading to revenue leakage. We
                          implemented end-to-end RPA automation to extract, merge, categorize,
                          auto-allocate, and upload recovery data seamlessly. The solution cut
                          manual effort by 85%, achieved 100% accuracy, eliminated revenue loss, and
                          reduced cycle time from weeks to minutes with a fully scalable, repeatable
                          process.
                        </p>
                      </div>
                      <span
                        className={styles.readFullCaseStudy}
                        onClick={() => setSelectedCaseStudy(clients.BSES)}
                      >
                        Read the full case study
                      </span>
                    </div>
                    <div className={styles.caseStudyImageContainer}>
                      <CaseStudyBSESImage />
                    </div>
                  </div>
                </div>
              </Carousel>
            </div>
          </div>
        </section>

        <section className={styles.animatedFeatureSlide}>
              <div className={styles.bgImageContainer}>
                <PurpleBg/>
              </div>
              <div className={`${styles.featureRow} ${styles.firstRow}`}>
                {features.map((item, index)=>(<span key={index} className={styles.featureTag}>{item}</span>))}
              </div>
              <div className={`${styles.featureRow} ${styles.scrollRight}`}>
                {features.map((item, index)=>(<span key={index} className={styles.featureTag}>{item}</span>))}
              </div>
              <div className={`${styles.featureRow} ${styles.scrollLeft}`}>
                {features.map((item, index)=>(<span key={index} className={styles.featureTag}>{item}</span>))}
              </div>
        </section>

        <section className={styles.peopleFeedbackSection}>
          <div className={styles.backgroundImageContainer}>
            <HowToTransformBgImage />
          </div>
          <div className={styles.sectionDetails}>
            <p className={styles.sectionTitle}>
              What people say about <br />
              us
            </p>
            <p className={styles.sectionDescription}>
              With lots of unique blocks, you can easily build a page without coding. Build your
              next landing page.
            </p>
            <button className={styles.contactUsButton} onClick={openRequestDemo}>
              Contact Us
            </button>
          </div>
          <div className={styles.feedbackCarouselContainer}>
            <Carousel
              autoplay
              autoplaySpeed={3000}
              dots
              pauseOnDotsHover
              className={styles.customCarouselStyles}
            >
              {PeopleFeedback.map((feedback, index) => (
                <div key={index}>
                  <div className={styles.feedbackCard}>
                    <p className={styles.feedbackText}>{feedback.feedbackText}</p>
                    <div className={styles.profileDetailsContainer}>
                      <div className={styles.profileImageContainer}>
                        {feedback.profileImage}
                      </div>
                      <div className={styles.nameRatingContainer}>
                        <span className={styles.nameText}>{feedback.feedbackBy}</span>
                        <div className={styles.ratingContainer}>
                          <RatingStart className={styles.filedStart} />
                          <RatingStart className={styles.filedStart} />
                          <RatingStart className={styles.filedStart} />
                          <RatingStart className={styles.filedStart} />
                          <RatingStart className={styles.filedStart} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>
          </div>
        </section>

        <section className={styles.globalFootPrintsSection}>
          <div className={styles.backgroundImageContainer}>
            <GlobalFootPrintBgImage className={styles.backgroundImage} />
          </div>
          <div className={styles.sectionHeadingContainer}>
            <div className={styles.companyNameContainer}>
              <LogoTft className={styles.tftLogo} />
              <span className={styles.tftText}>Think Future Technologies</span>
            </div>
            <span className={styles.sectionHeading}>
              Our global <span className={styles.pinkHeadingText}>footprints</span>
            </span>
          </div>
          <div className={styles.bottomContainer}>
            <div className={styles.leftContainer}>
              <div className={styles.bottomContentContainer}>
                <div className={styles.contactUsInfoContainer}>
                  <span className={styles.contactUsText}>Connect with us</span>
                  <div className={styles.contactUsEmailContainer}>
                    <MailIcon />
                    <span>info@tftus.com</span>
                  </div>
                </div>
                <div className={styles.contactUsInfoContainer}>
                  <div className={styles.contactUsEmailContainer}>
                    <SkypeIcon />
                    <span>sales.tft@outlook.com</span>
                  </div>
                </div>
              </div>
              <span className={styles.copyrightText}>
                Copyright © 2012-{new Date().getFullYear()} Think Future Technologies Private
                Limited. ALL RIGHTS RESERVED
              </span>
            </div>

            <div className={styles.socialMediaLinks}>
              <a
                href="https://www.linkedin.com/authwall?trk=bf&trkInfo=AQFZn_UaaWfeigAAAYoSXXuYLfNbpCaB8y4USb686GUmO7XCjyxu1I2gtqD0ZjHIsobaMEeoc53ogTazCSbZz3xpPPPms90giLrwltUyvDFsAXN6XBYMlz1WksH1mXrXBcaJV5k=&original_referer=&sessionRedirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2Fthink-future-technologies"
                target="_blank"
                rel="noreferrer"
              >
                <LinkedIcon />
              </a>
              <a href="https://www.facebook.com/TFTUS/" target="_blank" rel="noreferrer">
                <FacebookIcon />
              </a>
              <a href="https://www.instagram.com/tft_us/" target="_blank" rel="noreferrer">
                <InstagramIcon />
              </a>
              <a
                href="https://twitter.com/i/flow/login?redirect_after_login=%2FThinkFutureTech"
                target="_blank"
                rel="noreferrer"
              >
                <XIcon />
              </a>
            </div>
          </div>
        </section>
      </div>
      <CaseStudyModal
        open={!!selectedCaseStudy}
        onClose={() => setSelectedCaseStudy(null)}
      >
        {!CASE_STUDIES ? (
          <div className={styles.caseStudyLoader}><DoubleCircleLoader/></div>
        ) : selectedData ? (
          <CaseStudyContent data={selectedData} />
        ) : (
          <div className={styles.caseStudyLoader}><DoubleCircleLoader/></div>
        )}
      </CaseStudyModal>

      <RequestDemo
        open={isRequestDemo}
        onClose={closeRequestDemo}
      />
      <RequestDemo open={isRequestDemo} onClose={closeRequestDemo} />
    </>
  );
};

export default HomePageNew;
